import { useEffect, useState } from "react";
import { ACLResponse, USER_ACL } from "../types/types";
import { BACKEND_URL } from "../constants";


export function useACL() {
  const [acl, setACL] = useState<USER_ACL | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchACL = async () => {
      setLoading(true);
      setError(null);

      try {
        const token = localStorage.getItem("jwt");
        if (!token) {
          throw new Error("No token found");
        }

        const response = await fetch(`${BACKEND_URL}/auth/acl`, {
          headers: {
            Authorization: token,
          },
        });

        if (!response.ok) {
          const text = await response.text();
          throw new Error(text || "Failed to fetch ACL");
        }

        const data: ACLResponse = await response.json();
        let acl: USER_ACL = USER_ACL.USER;

        if (data.acl === 0) {
          acl = USER_ACL.ADMIN;
        }

        setACL(acl);
      } catch (err) {
        setError(err as Error);
        setACL(null);
      } finally {
        setLoading(false);
      }
    };

    fetchACL();
  }, []);

  return { acl, loading, error };
}
